import { render, staticRenderFns } from "./wallet_owner_types.vue?vue&type=template&id=2d79212c&scoped=true&"
import script from "./wallet_owner_types.vue?vue&type=script&lang=js&"
export * from "./wallet_owner_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d79212c",
  null
  
)

export default component.exports